/**
 * Central brand configuration for Chargestack Arc.
 *
 * All user-facing product names, taglines, icons, and asset paths
 * live here so a single edit propagates everywhere.
 *
 * When you have a custom emoji / image for Ask Arc or the Arc product,
 * just update ARC_ICON, ASK_ARC_ICON, and ARC_LOGO_PATH below.
 */

// ── Product identity ──────────────────────────────────────────
export const PRODUCT_NAME    = 'Chargestack Arc';
export const PRODUCT_SHORT   = 'Arc';
export const PRODUCT_TAGLINE = 'Ingest. Organize. Understand.';

// ── Agent identity ────────────────────────────────────────────
export const AGENT_NAME       = 'Ask Arc';
export const AGENT_NAME_SHORT = 'Arc';

// ── Icons / emojis (swap these when custom assets arrive) ─────
/** Icon shown next to the Arc product name (tab headers, nav, etc.) */
export const ARC_ICON = '⚡';

/** Icon shown next to Ask Arc agent messages and buttons */
export const ASK_ARC_ICON = '🤖';

// ── Asset paths (relative to public/) ─────────────────────────
/** Main product logo (PNG/SVG) — shown on login, navbar */
export const ARC_LOGO_PATH = '/chargestack-logo.png';

/** Favicon */
export const ARC_FAVICON_PATH = '/favicon.svg';
